// extracted by mini-css-extract-plugin
module.exports = {"reportThisEventButton":"ReportThisEventButton_reportThisEventButton__JBCxR","reportThisEventButtonText":"ReportThisEventButton_reportThisEventButtonText__K3lI_"};